module.exports = __webpack_public_path__ + "static/media/lcs_newbg.f3ca0f5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lcs_newbg.jpg
// module id = 1794
// module chunks = 0 1